import { render, staticRenderFns } from "./PreviewDialog.vue?vue&type=template&id=59645b98&"
import script from "./PreviewDialog.vue?vue&type=script&lang=js&"
export * from "./PreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59645b98')) {
      api.createRecord('59645b98', component.options)
    } else {
      api.reload('59645b98', component.options)
    }
    module.hot.accept("./PreviewDialog.vue?vue&type=template&id=59645b98&", function () {
      api.rerender('59645b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-file-preview/dialog/PreviewDialog.vue"
export default component.exports